module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-waiting-room-d2e36730a1350d8a557665f3f9efad2c.jpg";